var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCsvFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7062 9.02188C26.8937 9.20938 27 9.4625 27 9.72812V29C27 29.5531 26.5531 30 26 30H6C5.44687 30 5 29.5531 5 29V3C5 2.44687 5.44687 2 6 2H19.2719C19.5375 2 19.7938 2.10625 19.9813 2.29375L26.7062 9.02188ZM24.6938 10.1875L18.8125 4.30625V10.1875H24.6938Z",
    fill: "#537089"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2331 25.096C12.4091 25.096 13.0811 24.448 13.4651 23.784L12.4891 23.312C12.2651 23.752 11.7851 24.088 11.2331 24.088C10.2651 24.088 9.56109 23.344 9.56109 22.336C9.56109 21.328 10.2651 20.584 11.2331 20.584C11.7851 20.584 12.2651 20.928 12.4891 21.36L13.4651 20.88C13.0891 20.216 12.4091 19.576 11.2331 19.576C9.63309 19.576 8.39309 20.696 8.39309 22.336C8.39309 23.976 9.63309 25.096 11.2331 25.096ZM16.0373 25.096C17.4773 25.096 18.1733 24.36 18.1733 23.384C18.1733 21.392 15.1093 21.96 15.1093 21.112C15.1093 20.792 15.3813 20.576 15.8693 20.576C16.4133 20.576 16.9893 20.76 17.4213 21.16L18.0533 20.328C17.5253 19.84 16.8213 19.584 15.9733 19.584C14.7173 19.584 13.9493 20.32 13.9493 21.208C13.9493 23.216 17.0213 22.568 17.0213 23.512C17.0213 23.816 16.7173 24.104 16.0933 24.104C15.3573 24.104 14.7733 23.776 14.3973 23.384L13.7813 24.248C14.2773 24.752 15.0133 25.096 16.0373 25.096ZM21.8582 25L23.9142 19.664H22.6182L21.1462 23.768L19.6662 19.664H18.3702L20.4342 25H21.8582Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsvFileIcon);
export default __webpack_public_path__ + "static/media/csv-file-icon.effffd0cbe5f91ddcce479a94f9f643a.svg";
export { ForwardRef as ReactComponent };